import { ApplicationXml } from '../interfaces/applicationXml';
import { BaseAuthenticationResource } from './BaseAuthenticationResource';

export class ApplicationXmlResource extends BaseAuthenticationResource implements ApplicationXml {
  xml: Document = new Document();
  readonly applicationNumber = '';

  pk() {
    return this.applicationNumber;
  }
  static getEndpointExtra() {
    return {
      dataExpiryLength: 600000
    };
  }
  static urlRoot = '/api/Application/';
}
